import {
    SET_SCANME_DATA,
    RESET_SCANME_DATA
} from '../actionTypes';

// Action creator to set the travellerData in the Redux store
// Takes the fetched data as payload
export const setScanmeData = (data) => {
    console.log("Action: Setting ScanMe data in Redux store:", data); // For debugging
    return ({
        type: SET_SCANME_DATA,
        payload: data, // The actual travellerData fetched by the component
    });
}

// Action creator to reset the scanme state slice
export const resetScanmeData = () => ({
    type: RESET_SCANME_DATA,
});